import { IRace } from 'src/app/models/race.interface';

export interface IRaceState {
    race: IRace;
}

export const initialRaceState: IRaceState = {
    race: null
};
